// Merge a client's own tags with the org-level tags it inherits into one pool.
// Dedupe by tag name, preferring lower scoped client tags
export const mergeTags = (clientTags = [], orgTags = []) => {
    const byName = new Map();

    (orgTags || []).forEach((tag) => {
        if (tag?.tag != null) byName.set(tag.tag, tag);
    });
    (clientTags || []).forEach((tag) => {
        if (tag?.tag != null) byName.set(tag.tag, tag);
    });

    return Array.from(byName.values());
};
